import { newGuidWithoutHyphen } from '@/api/utils/guid'
import { printTracker } from './tracker'
import { qryDicDetailByCode } from '@/api/biz/shipment/pack/pack.js'
import { getSystemConfig } from '@/api/biz/master/masterService'
import * as barcodeBase64 from "@/api/print/barcodeBase64";
import { parseLooseJSON } from "@/api/utils/object";
import { print } from "@/api/print/print.js";
import { i18n } from '@/api/i18n';
import { createAsyncExportTask } from '@/api/biz/smartQuery/smartQueryService'
import route from '@/router.js';
import { userInfo} from '@/global';
import { querySystemConfigList } from "@/api/biz/shipment/shipmentService";
import QRCode from 'qrcode';
import {getSysConfigByKey} from '@/api/biz/master/masterService.js'


/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  // eslint-disable-next-line
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  // eslint-disable-next-line
  return time_str
}

/**
 * Parse the json to excel
 *  tableJson 导出数据 ; filenames导出表的名字; autowidth表格宽度自动 true or false; bookTypes xlsx & csv & txt
 * @param {(Object)} tableJson
 * @param {string} filenames
 * @param {boolean} autowidth
 * @param {string} bookTypes
 */
export function json2excel (tableJson, filenames, autowidth, bookTypes) {
  import('@/assets/js/Export2Excel').then(excel => {
    var tHeader = []
    var dataArr = []
    var sheetnames = []
    for (var i in tableJson) {
      tHeader.push(tableJson[i].tHeader)
      dataArr.push(formatJson(tableJson[i].filterVal, tableJson[i].tableDatas))
      sheetnames.push(tableJson[i].sheetName)
    }
    excel.export_multiple_json_to_excel({
      header: tHeader,
      data: dataArr,
      sheetname: sheetnames,
      filename: filenames,
      autoWidth: autowidth,
      bookType: bookTypes
    })
  })
}

// 数据过滤，时间过滤
function formatJson (filterVal, jsonData) {
  return jsonData.map(v =>
    filterVal.map(j => {
      if (j === 'timestamp') {
        return parseTime(v[j])
      } else {
        return v[j]
      }
    })
  )
}

export function urlToJson (url = window.location.href) {
  let obj = {};
  let index = url.indexOf('?');
  let params = url.substr(index + 1);

  if(index != -1) {
    let parr = params.split('&');
    for(let i of parr) {
      let arr = i.split('=');
      obj[arr[0]] = arr[1];
    }
  }
  return obj;
}

export function requestFullScreen (elementId){
  let de = document.getElementById(elementId)
  // let de = document.getElementsByClassName('right-content')[0]
  if (de.requestFullscreen) {
    de.requestFullscreen()
  } else if (de.mozRequestFullScreen) {
    de.mozRequestFullScreen()
  } else if(de.msRequestFullscreen) {
    de.msRequestFullscreen()
  } else if (de.webkitRequestFullScreen) {
    de.webkitRequestFullScreen()
  }
}
export function exitFullscreen () {
  let de = document
  if (de.exitFullscreen) {
    de.exitFullscreen()
  } else if (de.mozCancelFullScreen) {
    de.mozCancelFullScreen()
  } else if(de.msExitFullscreen) {
    de.msExiFullscreen()
  }  else if (de.webkitCancelFullScreen) {
    de.webkitCancelFullScreen()
  }
}
export function checkFromParameter(url,targetStr) {
  // 获取查询字符串部分
  const queryString = url.includes('?') ? (url.split('?')[1].split('#')[0] || '') : '';

  // 将查询字符串分割成键值对
  const params = queryString.split('&');

  // 遍历键值对并查找from参数
  for (let param of params) {
    const [key, value] = param.split('=');
    if (key === 'from') {
      return value === targetStr;
    }
  }

  // 如果没有找到from参数，返回false
  return false;
}
/**
 * 
 * @param item 
 * @param processTypeObj 
 * @param bizType 
 * @param type outbound/inbound
 */
export function createTableData(item, processTypeObj, bizType,type,isOneToMany) {
  return {
    bizNo: type === 'outbound' ? item.outboundNo : item.asnNo,
    goodsNo: type === 'outbound' ? item.goodsNo : item.itemCode, // 商品编码
    goodsName: type === 'outbound' ? item.goodsName : item.itemName, // 商品名称
    goodsBarcodeList: item.goodsBarcodeList,
    goodsAliasCode: type === 'outbound' ? item.goodsAliasCode : item.outGoodsNo,
    boxRuleCode: type === 'outbound' ? item.boxRuleCode : item.cartonSpecCode, // 箱规码
    quantity: 1,
    perSKUQuantity: 1,
    id: type === 'outbound' ? item.id : item.innerId,
    vasCode: isOneToMany ? '': processTypeObj.pCode,
    processCode: isOneToMany ? '': processTypeObj.code,
    bizType: bizType,
    processTarget: processTypeObj.processTarget
  };
}

/** 打印开始
 * aNode 打印场景
 * billNo 关联的单号
 * **/
export const printStart=({billNo,aNode})=>{
  if(!aNode && !window.printNode)return 
  const printStart=new Date().getTime()
  const printTrackObj={
    traceId : 'web_gjwms_'+newGuidWithoutHyphen(),
    printStart,
    points:[],
    aNode: aNode||window.printNode||'',
    billNo:billNo||'', //单号
    billNum:1,//打印多少张
  }
  window.printTrackObj=printTrackObj 
  console.log("🚀 ~ printStart ~ printStart:", aNode||window.printNode,printStart)
}


//打印结束，进行埋点上报，销毁全局变量printTrackObj、printNode
//isReport 是否要进行上报
//有些无效数据，不需要进行上报，但是全局变量要进行销毁，否则就会一直往里push数据，导致全局变量过大
export const printEnd=(isReport)=>{
  if(isReport && window.printTrackObj){
    const endTime=new Date().getTime()
    const netTimePoint = {
      point:'netTime',
      inTime:window.responseNetTime || 0
    }
    
    window.printTrackObj.inTime=endTime-window.printTrackObj.printStart
    window.printTrackObj.points && window.printTrackObj.points.push(netTimePoint)
    printTracker(window.printTrackObj.aNode, window.printTrackObj)

    console.log("🚀 ~ printEnd ~ endTime:", endTime)
    console.log("🚀 ~ cloudPrint ~ window.printTrackObj:", window.printTrackObj)
  }
  window.printTrackObj = null;
  window.printNode = null;
}


export const pushPrintPoint=(point,inTime,timeBegin)=>{
  if(inTime===0) return
  if(point==='addLog') return
  window.printTrackObj && window.printTrackObj.points.push({
    point,
    inTime,
    timeBegin,
    netTime:window.responseNetTime || 0
  })
}
export const printPointEnd=(printWay,startTime,exception)=>{
  const point={
    point:printWay,
    billNo:'',
    billNum:1,
    inTime:(new Date().getTime()-startTime) || 0,
    startTime
  }
  if(exception){
    const {eptCustMessage}=exception
    Object.assign(point,{
      eptType:2,
      eptSource:4,
      eptCustMessage
    })
  }
  window.printTrackObj&&window.printTrackObj.points.push(point)
}

export const changeANode=(newANode)=>{
  if(newANode && window.printTrackObj){
    window.printTrackObj.aNode=newANode
  }
}

export const loadScript = (url) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script ${url}`));
    document.head.appendChild(script);
  });
}

export const loadCss = (url)  => {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.href = url;
    link.rel = 'stylesheet';
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to load CSS ${url}`));
    document.head.appendChild(link);
  });
}

// 子不语商品条码解析
export const handleBarCode = (inputBarcode,zibuyuConfig) => {
  const { barcodeAnalysisSwitch, barcodeAnalysisExpression } = zibuyuConfig
  if (barcodeAnalysisSwitch === 1) {
    const regex = new RegExp(barcodeAnalysisExpression);
    if (regex.test(inputBarcode)) {
      const match = inputBarcode.match(regex);
      if (match && match.length > 1) {
        return match[1];
      }
    }
  }
  return inputBarcode;
}

export const queryZibuyuBarcodeAnalysis = async () => {
  try {
    let dicDetails = await qryDicDetailByCode(
      "zibuyuBarcodeAnalysis",
      userInfo
    );
    const zibuyuBarcodeAnalysis = dicDetails.length === 0 ? [] : [...dicDetails]
    const zibuyuConfig = {}
    zibuyuBarcodeAnalysis.forEach((item) => {
      if (item.code === 'barcodeAnalysisSwitch') {
        zibuyuConfig['barcodeAnalysisSwitch'] = Number(item.value)
      }
      if (item.code === 'barcodeAnalysisExpression') {
        zibuyuConfig['barcodeAnalysisExpression'] = item.value
      }
    })
    return zibuyuConfig
  } catch(e) {
    console.log(e.message)
  }
}
const defaultPrintConfig = {
  fontOptions: "bold",
  font: "bold",
  fontSize: 20,
  height: 60,
  width: 1.5,
  qrWidth: 120,
  qrMargin: 4
}
export const batchPrint =async (containerNoList, defaultContainerConfig, printNum = 1)=>{
  try{
    let barcodeRule = defaultPrintConfig
    const containerConfig = await getContainerConfig(defaultContainerConfig);

    containerNoList.forEach(async containerNo=>{
      try {
        barcodeRule = containerNo.startsWith("000010")?containerConfig["container_print_config"]:containerConfig["new_container_print_config"]
        let barcodeImg = barcodeBase64.getBarcodeBase64(containerNo,barcodeRule);
        let content = {}
        content.base64BinaryEncoding = barcodeImg;
        content.printerName = "Container";
        await print(content, printNum); 
      } catch (error) {
        console.log("🚀 ~ batchPrint ~ error:", error)
      }
    })
  }catch(e){
    console.error(e)
  }
}


export const batchPrintQrCode = async (containerNoList, defaultContainerConfig, printNum = 1, printerName) => {
  try {
    const containerConfig = await getContainerConfig(defaultContainerConfig);
    for (const containerNo of containerNoList) {
      if (!containerNo) {
        continue;
      }
      try {
        const rule = containerNo.startsWith("000010") ? containerConfig["container_print_config"] : containerConfig["new_container_print_config"];

        // Canvas 布局参数：height 是二维码高度，整张图高度由上边距、二维码和底部文字共同决定。
        const parseRuleNumber = (value, fallback) => {
          const numberValue = parseFloat(value);
          return Number.isFinite(numberValue) ? numberValue : fallback;
        };
        const qrSize = Math.round(parseRuleNumber(rule.height, defaultPrintConfig.height)) * 1.6;
        const fontSize = parseRuleNumber(rule.fontSize, 20);
        const minFontSize = Math.min(8, fontSize);
        const paddingTop = Math.max(0, parseRuleNumber(rule.qrPaddingTop || rule.marginTop, 0));
        const paddingBottom = Math.max(0, parseRuleNumber(rule.qrPaddingBottom, Math.round(fontSize * 0.2)));
        const textAreaHeight = Math.max(minFontSize + 2, Math.ceil(fontSize * 1.25));
        const canvasHeight = Math.ceil(paddingTop + qrSize + textAreaHeight + paddingBottom);
        const paddingX = Math.max(0, parseRuleNumber(rule.qrPaddingX || rule.marginLeft, Math.round(qrSize * 0.25)));
        const configuredGap = parseRuleNumber(rule.qrGap || rule.qrMargin, Math.round(qrSize * 0.18));
        const gap = Math.max(0, configuredGap);
        const qrTotalWidth = qrSize * 4 + gap * 3;
        const drawFontSize = Math.max(minFontSize, fontSize);
        const fontOptions = rule.fontOptions || '';
        const fontFamily = rule.font || 'monospace';
        const canvasFont = `${fontOptions} ${drawFontSize}px ${fontFamily}`.trim();
        const measureCanvas = document.createElement('canvas');
        const measureCtx = measureCanvas.getContext('2d');
        measureCtx.font = canvasFont;
        const textWidth = Math.ceil(measureCtx.measureText(containerNo).width);
        const canvasWidth = Math.ceil(Math.max(qrTotalWidth, textWidth) + paddingX * 2);
        const qrStartX = Math.round((canvasWidth - qrTotalWidth) / 2);
        const qrImageSize = Math.max(120, qrSize * 4);

        // 生成高分辨率二维码后缩放绘制，避免目标尺寸较小时二维码被生成成空白或过度模糊。
        const qrDataUrl = await new Promise((resolve, reject) => {
          QRCode.toDataURL(containerNo, { width: qrImageSize, margin: 0 }, (err, url) => {
            if (err) reject(err);
            else resolve(url);
          });
        });

        const canvas = document.createElement('canvas');
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        const ctx = canvas.getContext('2d');
        ctx.imageSmoothingEnabled = false;

        // 白色背景
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);

        // 加载二维码图片
        const qrImg = await new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = qrDataUrl;
        });

        // 绘制 4 个相同的二维码横向排列
        for (let i = 0; i < 4; i++) {
          const x = qrStartX + i * (qrSize + gap);
          ctx.drawImage(qrImg, x, paddingTop, qrSize, qrSize);
        }

        // 绘制底部储位号文字（以配置的 fontSize 为起始字号，自动缩小适配宽度）
        ctx.font = canvasFont;
        ctx.fillStyle = '#000000';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(containerNo, canvasWidth / 2, paddingTop + qrSize + textAreaHeight / 2);

        const base64 = canvas.toDataURL('image/png');
        // console.log(base64)
        let content = {};
        content.base64BinaryEncoding = base64.split('base64,')[1];
        content.printerName = printerName || 'Container';
        await print(content, printNum);
        
      } catch (error) {
        console.log('🚀 ~ batchPrintQrCode ~ error:', error);
      }
    }
  } catch (e) {
    console.error(e);
  }
}


// 提取配置获取逻辑
export async function getContainerConfig(defaultContainerConfig) {
  if (defaultContainerConfig) {
    return defaultContainerConfig;
  }

  const containerConfig = {
    container_print_config: defaultPrintConfig,
    new_container_print_config: defaultPrintConfig
  };

  try {
    const resultList = await querySystemConfigList({
      keys: ["container_print_config", "new_container_print_config"]
    });

    resultList.forEach(item => {
      if (typeof item.value !== "undefined" && item.value !== "") {
        try {
          containerConfig[item.key] = parseLooseJSON(item.value, containerConfig[item.key])
        } catch (e) {
          console.error(`Invalid config value for ${item.key}:`, e);
        }
      }
    });

    return containerConfig;
  } catch (error) {
    console.error('Failed to fetch container config:', error);
    return containerConfig; // 返回默认配置
  }
}


export const commonAsyncExport =async (params,searchForm) => {
  const { userCode } = userInfo;
  const { headList, znHeadList, exportMethod } = params
  const condition = {
    ...searchForm,
    userCode: userCode,
    userName: userCode
  }
  const exportParams={
    taskType: exportMethod,
    createUser: userCode,
    conditionJson:JSON.stringify(condition),
    headList: headList,
    znHeadList: znHeadList,
    envType: i18n._vm.locale,
  }
  console.log("🚀 ~ invopExport ~ exportParams:", exportParams)
  await createAsyncExportTask(exportParams)
  route.push({ path: '/smartQuery/asyncDownload' });
}

export const getBtnPermission = (btnCode)=>{
  const btnPermissions = JSON.parse(localStorage.getItem('btnPermissions') || '[]');
  if (btnPermissions.length === 0) {
    return false
  }
  const hasPermission = btnPermissions.includes(btnCode);
  if (!hasPermission) {
    return false
  }
  return true
}

/**
 * 单位转换函数
 * 支持长度、重量、体积、电池容量等单位的相互转换
 * 解决JavaScript浮点数精度问题
 * @param {number} value - 要转换的数值
 * @param {string} fromUnit - 源单位
 * @param {string} toUnit - 目标单位
 * @returns {number} - 转换后的数值，失败时返回原始value
 */
export function convertUnit(value, fromUnit, toUnit) {
  fromUnit = fromUnit?.toLowerCase();
  toUnit = toUnit?.toLowerCase();
  console.log(`fromUnit:${fromUnit}`, `toUnit:${toUnit}`);
  // 单位配置 - 所有单位都转换为基准单位的系数
  const unitConfig = {
    // 长度单位 (基准: 米)
    LENGTH: {
      'km': 0.001, '千米': 0.001,
      'm': 1, '米': 1,
      'dm': 10, '分米': 10,
      'cm': 100, '厘米': 100,
      'mm': 1000, '毫米': 1000,
      'um': 1000000, '微米': 1000000,
      'nm': 1000000000, '纳米': 1000000000,
      'in': 39.3700787, 'inch': 39.3700787, '英寸': 39.3700787,
      'ft': 3.2808399, 'feet': 3.2808399, '英尺': 3.2808399
    },
    // 重量单位 (基准: 千克)
    WEIGHT: {
      't': 0.001,
      'kg': 1,
      'g': 1000,
      'mg': 1000000,
      'μg': 1000000000,
      'lb': 2.2046226, 
      'lbs': 2.2046226,
      'oz': 35.2739619,
      'ct': 5000
    },
    // 体积单位 (基准: 立方米)
    VOLUME: {
      'cbm': 1,
      'cbdm': 1000,
      'cbcm': 1000000,
      'cbmm': 1000000000,
      'cbft': 35.3147248,
      'cbin': 61023.8445022
    },
    // 电池容量单位 (基准: 瓦时)
    BATTERY_CAPACITY: {
      'wh': 1
    }
  };
  // 输入验证
  if (typeof value !== 'number' || isNaN(value)) {
    return value;
  }

  if (!fromUnit || !toUnit) {
    return value;
  }

  // 如果单位相同直接返回
  if (fromUnit === toUnit) {
    return value;
  }

  // 查找单位所属类别和转换系数
  let fromFactor = null;
  let toFactor = null;

  for (const [cat, units] of Object.entries(unitConfig)) {
    if (units[fromUnit] !== undefined && units[toUnit] !== undefined) {
      fromFactor = units[fromUnit];
      toFactor = units[toUnit];
      break;
    }
  }

  if (fromFactor === null || toFactor === null) {
    return value;
  }

  try {
    // 高精度计算：先转换为基准单位，再转换为目标单位
    // 使用字符串计算避免浮点数精度问题
    const baseValue = multiplyPrecise(value.toString(), (1 / fromFactor).toString());
    const result = multiplyPrecise(baseValue, toFactor.toString());
    
    return parseFloat(result);
  } catch (error) {
    return value;
  }
}

/**
 * 高精度乘法运算
 * @param {string} num1 
 * @param {string} num2 
 * @returns {string}
 */
function multiplyPrecise(num1, num2) {
  const n1 = parseFloat(num1);
  const n2 = parseFloat(num2);
  
  // 获取小数位数
  const decimal1 = (num1.split('.')[1] || '').length;
  const decimal2 = (num2.split('.')[1] || '').length;
  const totalDecimals = decimal1 + decimal2;
  
  // 转换为整数计算
  const int1 = Math.round(n1 * Math.pow(10, decimal1));
  const int2 = Math.round(n2 * Math.pow(10, decimal2));
  
  const result = (int1 * int2) / Math.pow(10, totalDecimals);
  
  // 保留合理的小数位数
  return totalDecimals > 0 ? result.toFixed(Math.min(totalDecimals, 10)) : result.toString();
}

/**
 * 获取支持的单位列表
 * @param {string} category - 可选，指定类别
 * @returns {Object|Array}
 */
export function getSupportedUnits(category) {
  const units = {
    LENGTH: ['km', 'm', 'dm', 'cm', 'mm', 'um', 'nm', 'in', 'ft'],
    WEIGHT: ['t', 'kg', 'g', 'mg', 'μg', 'ug', 'lb', 'oz', 'ct'],
    VOLUME: ['cbm', 'cbdm', 'cbcm', 'cbmm', 'cbft', 'cbin'],
    BATTERY_CAPACITY: ['wh']
  };
  
  return category ? units[category] || [] : units;
}



export const gengerateQRUrlByObj = (codeObj, needBase64 = false) => {
  return new Promise((resolve, reject) => {
    const codeString = JSON.stringify(codeObj);
    
    let qrString = codeString;
    if (needBase64) {
      qrString = window.btoa(unescape(encodeURIComponent(codeString)));
    }
    QRCode.toDataURL(qrString, (err, url) => {
      if (err) {
        console.error(err);
        reject(err);
        return;
      }
      resolve(url);
    });
  });
}

export const getSystemConfigByKey =async (key) => {
  let res = await getSysConfigByKey(key)
  console.log("🚀 ~ getSystemConfigByKey ~ res:", res)
  return res
}

export const getSystemConfigByList = async (keyList) => {
  let resultList = await querySystemConfigList({ keys: keyList })
  console.log("🚀 ~ getSystemConfigByList ~ res:", resultList)
  return resultList
}